import { ChainId } from '@ourzora/chains'
import { ZORA } from '@ourzora/contracts'
import { EncodeAbiParametersReturnType, getAddress, parseUnits, zeroAddress } from 'viem'
import { base } from 'viem/chains'
import { encodePoolConfig } from './utils'

export const COIN_PLATFORM_REFFERER = zeroAddress

/**
 * ==========================
 * COIN_ZORA_PAIR_POOL_CONFIG
 * ==========================
 */

export const COIN_ZORA_PAIR_POOL_CONFIG_VERSION = 4
export const COIN_ZORA_PAIR_LOWER_TICKS = [-138_000] // ( -250000 in ETH land ~= $23 = -138_000 in Zora token land at .022)
export const COIN_ZORA_PAIR_UPPER_TICKS = [-81_000] // (-195_000 ~= 5782 =  -81_000 in Zora token land at .022)
export const COIN_ZORA_PAIR_NUM_DISCOVERY_POSITIONS = [11]
export const COIN_ZORA_PAIR_MAX_DISCOVERY_SUPPLY_SHARES = [parseUnits('0.05', 18)]

export const COIN_ZORA_PAIR_POOL_CONFIG = {
  [base.id]: encodePoolConfig(
    COIN_ZORA_PAIR_POOL_CONFIG_VERSION,
    ZORA.address[base.id],
    COIN_ZORA_PAIR_LOWER_TICKS,
    COIN_ZORA_PAIR_UPPER_TICKS,
    COIN_ZORA_PAIR_NUM_DISCOVERY_POSITIONS,
    COIN_ZORA_PAIR_MAX_DISCOVERY_SUPPLY_SHARES
  ),
} satisfies Partial<Record<ChainId, EncodeAbiParametersReturnType>>

export const COIN_ZORA_V4_PAIR_POOL_CONFIG_VERSION_2K = 4
export const COIN_ZORA_PAIR_LOWER_TICKS_2K = [-92_000]
export const COIN_ZORA_PAIR_UPPER_TICKS_2K = [-81_000]
export const COIN_ZORA_PAIR_NUM_DISCOVERY_POSITIONS_2K = [11]
export const COIN_ZORA_PAIR_MAX_DISCOVERY_SUPPLY_SHARES_2K = [parseUnits('0.05', 18)]

export const COIN_ZORA_PAIR_POOL_CONFIG_2K = {
  [base.id]: encodePoolConfig(
    COIN_ZORA_V4_PAIR_POOL_CONFIG_VERSION_2K,
    ZORA.address[base.id],
    COIN_ZORA_PAIR_LOWER_TICKS_2K,
    COIN_ZORA_PAIR_UPPER_TICKS_2K,
    COIN_ZORA_PAIR_NUM_DISCOVERY_POSITIONS_2K,
    COIN_ZORA_PAIR_MAX_DISCOVERY_SUPPLY_SHARES_2K
  ),
} satisfies Partial<Record<ChainId, EncodeAbiParametersReturnType>>

/**
 * ==========================
 * COIN_CREATOR_COIN_PAIR_POOL_CONFIG
 * ==========================
 */

export const COIN_CREATOR_COIN_PAIR_POOL_CONFIG_VERSION = 4
export const COIN_CREATOR_COIN_PAIR_LOWER_TICKS = [-54_000, -30_000, -39_000]
export const COIN_CREATOR_COIN_PAIR_UPPER_TICKS = [-7000, 7000, 7000]
export const COIN_CREATOR_COIN_PAIR_NUM_DISCOVERY_POSITIONS = [11, 11, 11]
export const COIN_CREATOR_COIN_PAIR_MAX_DISCOVERY_SUPPLY_SHARES = [
  parseUnits('0.1', 18),
  parseUnits('0.1', 18),
  parseUnits('0.05', 18),
]

/**
 * ==========================
 * CREATOR_COIN_ZORA_PAIR_POOL_CONFIG
 * ==========================
 */

// Creator coin ~$1k mcap
export const CREATOR_COIN_ZORA_PAIR_POOL_CONFIG_VERSION = 4
export const CREATOR_COIN_ZORA_PAIR_LOWER_TICKS_MULTICURVE = [-90_000, -74_000, -62_000]
export const CREATOR_COIN_ZORA_PAIR_UPPER_TICKS_MULTICURVE = [-58_500, -67_000, -52_000]
export const CREATOR_COIN_ZORA_PAIR_NUM_DISCOVERY_POSITIONS_MULTICURVE = [11, 11, 11]
export const CREATOR_COIN_ZORA_PAIR_MAX_DISCOVERY_SUPPLY_SHARES_MULTICURVE = [
  parseUnits('0.05', 18),
  parseUnits('0.1', 18),
  parseUnits('0.1', 18),
]

// Creator coin ~$50k mcap
export const CREATOR_COIN_PAIR_LOWER_TICKS_50K = [-50_000, -46_500]
export const CREATOR_COIN_PAIR_UPPER_TICKS_50K = [-43_500, -34_500]
export const CREATOR_COIN_PAIR_NUM_DISCOVERY_POSITIONS_50K = [11, 11]
export const CREATOR_COIN_PAIR_MAX_DISCOVERY_SUPPLY_SHARES_50K = [
  parseUnits('0.1', 18),
  parseUnits('0.15', 18),
]

// Export default pool config values for reuse
export const DEFAULT_POOL_CONFIG = {
  VERSION: CREATOR_COIN_ZORA_PAIR_POOL_CONFIG_VERSION,
  PAIR_TOKEN_ADDRESS: ZORA.address[base.id],
  LOWER_TICKS: CREATOR_COIN_ZORA_PAIR_LOWER_TICKS_MULTICURVE,
  UPPER_TICKS: CREATOR_COIN_ZORA_PAIR_UPPER_TICKS_MULTICURVE,
  NUM_DISCOVERY_POSITIONS: CREATOR_COIN_ZORA_PAIR_NUM_DISCOVERY_POSITIONS_MULTICURVE,
  MAX_DISCOVERY_SUPPLY_SHARES:
    CREATOR_COIN_ZORA_PAIR_MAX_DISCOVERY_SUPPLY_SHARES_MULTICURVE,
} as const

/**
 * https://linear.app/ourzora/issue/MOON-3131/update-backend-to-point-to-the-new-hooks
 */
export const BROKEN_CONTENT_COIN_HOOK_ADDRESS = getAddress(
  '0xd3d133469adc85e01a4887404d8ac12d630e9040'
)

/**
 * https://linear.app/ourzora/issue/MOON-3131/update-backend-to-point-to-the-new-hooks
 */
export const BROKEN_CREATOR_COIN_HOOK_ADDRESS = getAddress(
  '0xffF800B76768dA8AB6aab527021e4a6A91219040'
)

/**
 * https://linear.app/ourzora/issue/MOON-3131/update-backend-to-point-to-the-new-hooks
 */
export const NEW_CONTENT_COIN_HOOK_ADDRESS = getAddress(
  '0x5bF219b3Cc11E3f6Dd8dc8fC89D7d1deB0431040'
)

/**
 * https://linear.app/ourzora/issue/MOON-3131/update-backend-to-point-to-the-new-hooks
 */
export const NEW_CREATOR_COIN_HOOK_ADDRESS = getAddress(
  '0x5e5D19d22c85A4aef7C1FdF25fB22A5a38f71040'
)
